import { render } from "./treeV3.vue?vue&type=template&id=5b3ba242"
import script from "./treeV3.vue?vue&type=script&lang=js"
export * from "./treeV3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__